import React from "react";
import { TextField } from "@material-ui/core";

const AppFormField = ({
  name: fieldName,
  label = "",
  labelId = "",
  size = null,
  id = "",
  type = "text",
  variant = null,
  disabled = false,
  ...rest
}) => {

  const handleBlur = () => {
    setTimeout(() => {
      rest.setFieldTouched(fieldName, true);
    }, 100);
  };

  const handleChange = (event) => {
    rest.setFieldValue(fieldName, event.currentTarget.value);
  };

  return (
      <React.Fragment>
          <TextField 
               variant={variant} 
               name={fieldName} 
               label={label}
               fullWidth
               size={size}
               type={type}
               disabled={disabled}
               InputLabelProps={{id: (labelId ? labelId : `${fieldName}-label`)}}
               id={id ? id : fieldName}
               FormHelperTextProps={{classes: { error: "validation-message" } }}
               value={rest.values[fieldName]}
               onChange={handleChange}
               onBlur={handleBlur}
               error={rest.touched[fieldName] && Boolean(rest.errors[fieldName])}
               helperText={rest.touched[fieldName] && rest.errors[fieldName]}
           />
      </React.Fragment>
  );
};

AppFormField.defaultProps = {
    variant: "outlined",
    size: "small", // small | medium
}

export default AppFormField;
